import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    goodGives: [],
    goodGiveFilters: null,
    goodGiveStatuses: [],
    goodGiveSearched: [],
    goodGive: {
      history: [],
    },
    goodGiveAvailable: [],
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
